import React, { useState, useEffect } from 'react';
import { GlobalAction } from '../types/GlobalAction';
import { Button, Form, Spinner } from 'react-bootstrap';

interface GlobalActionFormProps {
  key: string,
  initialData?: GlobalAction; // Edit mode if present
  onSave: (updated: Partial<GlobalAction>) => void;
  isLoading?: boolean;
  sdg?: 'all' | number;
}

const GlobalActionForm: React.FC<GlobalActionFormProps> = ({ key, initialData, onSave, isLoading, sdg }) => {
  const [currSdg, setCurrSdg] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<Partial<GlobalAction>>({
    title: '',
    description: '',
    sdg: currSdg,
    piResource: '',
    resourceUrl: '',
    source: '',
  });

  useEffect(() =>{
    setLoading(isLoading || false);
  },[isLoading])

  useEffect(() => {
    if (initialData) {
      setFormData({ ...initialData });
    } else {
      const resolvedSdg = sdg && sdg !== 'all' ? sdg : 1;
      setCurrSdg(resolvedSdg);
      setFormData({
        title: '',
        description: '',
        sdg: resolvedSdg,
        piResource: '',
        resourceUrl: '',
        source: '',
      });
    }
  }, [initialData?.id, sdg]);

  const handleChange = (field: keyof GlobalAction, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  const formIsValid = !!formData.title && !!formData.description && !!formData.sdg;

  return (
    <Form onSubmit={handleSubmit}>
      <div className="mb-3">
        <h4>{initialData?.id ? 'Update' : 'Create'} Global Action for SDG {sdg}</h4>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="title"
          type="text"
          placeholder="Title"
          value={formData.title || ''}
          onChange={(e) => handleChange('title', e.target.value)}
          required
        />
        <Form.Label htmlFor="title">Title <span className="text-danger">*</span></Form.Label>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="description"
          as="textarea"
          placeholder="Description"
          style={{ height: '100px' }}
          value={formData.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <Form.Label htmlFor="description">Description <span className="text-danger">*</span></Form.Label>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="sdg"
          type="number"
          min={1}
          max={17}
          placeholder="SDG"
          value={formData.sdg || ''}
          onChange={(e) => handleChange('sdg', parseInt(e.target.value))}
        />
        <Form.Label htmlFor="sdg">SDG <span className="text-danger">*</span></Form.Label>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="pi_resource"
          type="text"
          placeholder="PI Resource"
          value={formData.piResource || ''}
          onChange={(e) => handleChange('piResource', e.target.value)}
        />
        <Form.Label htmlFor="pi_resource">PI Resource</Form.Label>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="resource_url"
          type="text"
          placeholder="Resource URL"
          value={formData.resourceUrl || ''}
          onChange={(e) => handleChange('resourceUrl', e.target.value)}
        />
        <Form.Label htmlFor="resource_url">Resource URL</Form.Label>
      </div>

      <div className="form-floating mb-3">
        <Form.Control
          id="source"
          type="text"
          placeholder="Source"
          value={formData.source || ''}
          onChange={(e) => handleChange('source', e.target.value)}
        />
        <Form.Label htmlFor="source">Source</Form.Label>
      </div>

      <Button variant="primary" type="submit" disabled={loading || !formIsValid}>
        {initialData ? 'Update ' : 'Create '}
        {loading ? <Spinner animation="border" size="sm" />: ''} 
      </Button>
    </Form>

  );
};

export default GlobalActionForm;
